module.exports = __webpack_public_path__ + "static/PaperAndPen-1eec2368068e03177c9deef49ed9452e.jpg";